import IconAlertTriangle from "@/icons/IconAlertTriangle";
import {
  IconClose,
  Modal,
  PrimaryBlueButton,
  SecondaryBlueButton
} from "@velaro/velaro-component-lib";
import React from "react";

interface Props {
  onClose: () => void;
  onDelete: () => void;
}

export default function DeleteModal(props: Props) {
  return (
    <Modal show={true}>
      <div className="w-[400px]p-6">
        <div className="flex justify-between items-center mb-6">
          <div className="flex items-center">
            <IconAlertTriangle className="text-crimson-red-500" />
            <div className="text-xl font-medium ml-2">Delete Chat Window</div>
          </div>
          <IconClose
            className="text-slate-500 hover: cursor-pointer"
            onClick={props.onClose}
          />
        </div>
        <div className="flex text-sm font-normal mb-6 justify-center">
          Are you sure you want to delete this chat window?
        </div>
        <div className="flex justify-center items-center gap-4">
          <SecondaryBlueButton label="Cancel" onClick={props.onClose} />
          <PrimaryBlueButton label="Delete" onClick={props.onDelete} />
        </div>
      </div>
    </Modal>
  );
}
